
    import { Component, Vue } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    // 替换原有表单，引入拆分后的两个表单
    import PackingPlanBaseForm from './packing-plan-base-form.vue' // 基础信息（仅批次号）
    import PackingPlanExtraForm from './packing-plan-extra-form.vue' // 扩展信息（唛头/运单/备注）
    import PackingDetailForm from './packing-detail-form.vue'
    import PrintWaybillForm from './print-pack-from.vue';
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import DateUtils from '@/common/js/DateUtils'
    import moment from 'moment'

    // 下拉框选项类型
    interface SelectOption {
        value: boolean | null;
        label: string;
    }

    // 装箱批次查询参数
    class PackingBatchSearchRequest extends PageRequest {
        userId?: number;
        startDate?: Date;
        endDate?: Date;
        shippingMark: string = '';
        boxBatchNumber: string = '';
        trackingNumber: string = '';
        storeId?: number | null;
        isProcessed?: boolean | null;
        isSelf?: boolean | null;
    }

    // 装箱批次列表项类型
    interface PackingBatchListItem {
        Id: number;
        BoxBatchNumber: string;
        ShippingMark: string;
        TrackingNumber: string;
        StoreId: number;
        StoreName: string;
        CreationTime: Date;
        IsSelf: boolean;
        IsProcessed: boolean;
        Remark: string;
        InStockList: any[];
        PackingDetailList: any[];
    }

    @Component({
        name: "packingbatchmanager",
        components: { PackingPlanBaseForm, PackingPlanExtraForm, PackingDetailForm, PrintWaybillForm } // 注册拆分后的表单组件
    })
    export default class PackingBatchManager extends AbpBase {
        // 弹窗控制：新增基础/扩展弹窗，保留详情弹窗
        baseModalShow: boolean = false; // 基础信息（仅批次号）弹窗
        extraModalShow: boolean = false; // 扩展信息（唛头/运单/备注）弹窗
        detailModalShow: boolean = false;
        currentPackingPlanId: number = 0;
        currentPackingDetailList: any[] = [];
        currentProductIds: number[] = []; // 新增：存储当前行入库单的产品内码列表
        printModalShow: boolean = false; // 打印弹框显示状态
        currentRowData: any = null; // 存储当前点击行的完整数据

        // 仓库列表
        storeaddressList: Array<storeaddressInfo> = [];
        // 查询参数
        pagerequest: PackingBatchSearchRequest = new PackingBatchSearchRequest();
        // 日期范围
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];

        // 下拉选项
        IsSelfOptions: SelectOption[] = [
            { value: null, label: '全部' },
            { value: true, label: '是' },
            { value: false, label: '否' }
        ];
        IsProcessedOptions: SelectOption[] = [
            { value: null, label: '全部' },
            { value: true, label: '是' },
            { value: false, label: '否' }
        ];

        // 获取列表数据
        get list(): PackingBatchListItem[] {
            return this.$store.state.frontPackingBatch.list;
        };

        get loading(): boolean {
            return this.$store.state.frontPackingBatch.loading;
        }

        get pageSize(): number {
            return this.$store.state.frontPackingBatch.pageSize;
        }

        get totalCount(): number {
            return this.$store.state.frontPackingBatch.totalCount;
        }

        get currentPage(): number {
            return this.$store.state.frontPackingBatch.currentPage;
        }

        // 列配置：调整操作栏，拆分编辑按钮
        columns = [
            {
                title: '基本信息',
                width: 250,
                fixed: 'left',
                render: (h: any, params: any) => {
                    const row = params.row;
                    return h('div', [
                        h('h3', `装箱批次号：${row.boxBatchNumber || ''}`),
                        h('h3', `仓库名称：${row.storeName || ''}`),
                        h('h3', `是否自装箱：${row.isSelf ? '是' : '否'}`),
                        h('h3', `是否已处理：${row.isProcessed ? '是' : '否'}`),
                        h('h3', `创建时间：${DateUtils.formatLongDate(new Date(row.creationTime))}`)
                    ]);
                }
            },
            {
                title: '装箱信息',
                width: 200,
                render: (h: any, params: any) => {
                    const row = params.row;
                    return h('div', [
                        h('h3', `总箱数：${row.maxBox || ''}`),
                        h('h3', `唛头：${row.shippingMark || ''}`),
                        h('h3', `运单号：${row.trackingNumber || ''}`),
                        h('h3', `备注：${row.remark || '无'}`)
                    ]);
                }
            },
            {
                title: '装箱记录',
                width: 520, // 加宽适配5列数据
                render: (h: any, params: any) => {
                    const row = params.row;
                    const packingList = row.packingDetailList || []; // 列表返回实体首字母小写
                    if (packingList.length === 0) {
                        return h('span', '暂无装箱记录');
                    }

                    // 装箱记录表头：对应 PackingBatchDetailDto 字段
                    const packingHeader = ['箱号', '产品ID', '用户ID', '装箱数量', '装箱时间'];
                    // 统一清除默认间距，仅保留横向滚动
                    return h('div', { style: { overflow: 'auto', margin: '0', padding: '0' } }, [
                        h('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: '12px', margin: '0', padding: '0' } }, [
                            h('thead', [
                                h('tr', { style: { background: '#f5f5f5', margin: '0', padding: '0' } },
                                    packingHeader.map((header, idx) => {
                                        let thStyle: any = {
                                            border: '1px solid #eee',
                                            padding: '8px 5px',
                                            textAlign: 'center',
                                            whiteSpace: 'nowrap',
                                            fontWeight: 'bold',
                                            margin: '0',
                                        };
                                        // 按列配置宽度
                                        switch (idx) {
                                            case 0: thStyle.width = '50px'; break; // 箱号
                                            case 1: thStyle.width = '80px'; break; // 产品ID
                                            case 2: thStyle.width = '80px'; break; // 用户ID
                                            case 3: thStyle.width = '80px'; break; // 装箱数量
                                            case 4: thStyle.width = '180px'; break; // 装箱时间
                                            default: thStyle.width = '100px'; break;
                                        }
                                        return h('th', { key: idx, style: thStyle }, header);
                                    })
                                )
                            ]),
                            h('tbody',
                                packingList.map((packing: any, index: number) => {
                                    // 适配 DTO 首字母小写（列表返回数据）
                                    const boxNum = packing.boxNumber || 0;
                                    const productId = packing.productId || 0;
                                    const userId = packing.userId || 0;
                                    const productNums = packing.productNums || 0;
                                    const createTime = packing.creationTime
                                        ? DateUtils.formatLongDate(new Date(packing.creationTime))
                                        : '';

                                    return h('tr', {
                                        key: index,
                                        style: {
                                            '&:hover': { background: '#fafafa' }, // hover 高亮
                                            margin: '0',
                                            padding: '0'
                                        }
                                    }, [
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, boxNum),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, productId),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, userId),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, productNums),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, createTime)
                                    ]);
                                })
                            )
                        ])
                    ]);
                }
            },
            {
                title: '入库单记录',
                width: 600,
                render: (h: any, params: any) => {
                    const row = params.row;
                    const stockList = row.inStockList || [];
                    if (stockList.length === 0) {
                        return h('span', '暂无入库单记录');
                    }

                    const tableHeader = ['计划批次', '产品内码', '产品数量', '装箱数量', '状态'];
                    // 关键修改1：添加 margin: 0; padding: 0; 清除外层空白
                    return h('div', { style: { overflow: 'auto', margin: '0', padding: '0' } }, [
                        // 关键修改2：表格添加 margin: 0; padding: 0; 清除表格默认空白
                        h('table', { style: { width: '100%', borderCollapse: 'collapse', fontSize: '12px', margin: '0', padding: '0' } }, [
                            h('thead', [
                                // 关键修改3：表头行添加 margin: 0; padding: 0;
                                h('tr', { style: { background: '#f5f5f5', margin: '0', padding: '0' } },
                                    tableHeader.map((header, idx) => {
                                        let thStyle: any = {
                                            border: '1px solid #eee',
                                            padding: '8px 5px',
                                            textAlign: 'center',
                                            whiteSpace: 'nowrap',
                                            margin: '0'
                                        };
                                        switch (idx) {
                                            case 0: thStyle.width = '200px'; break;
                                            case 2: thStyle.width = '80px'; break;
                                            case 3: thStyle.width = '80px'; break;
                                            default: thStyle.width = '100px'; break;
                                        }
                                        return h('th', { key: idx, style: thStyle }, header);
                                    })
                                )
                            ]),
                            h('tbody',
                                stockList.map((stock: any, index: number) => {
                                    const statusText = this.ProductStatus.find(item => item.value === stock.productStatus).name || ''; // 可选链避免报错
                                    // 1. 获取产品数量和装箱数量（兼容空值，转为数字类型）
                                    const productNums = Number(stock.productNums) || 0;
                                    const boxNumber = Number(stock.boxNumber) || 0;
                                    // 2. 判断数量是否不一致
                                    const isNumsMismatch = productNums !== boxNumber;
                                    // 3. 装箱数量单元格动态样式（不一致时红色加粗）
                                    const boxNumberTdStyle = {
                                        border: '1px solid #eee',
                                        padding: '8px 5px',
                                        textAlign: 'center',
                                        color: isNumsMismatch ? 'red' : 'inherit', // 不一致时红色
                                        fontWeight: isNumsMismatch ? 'bold' : 'normal', // 不一致时加粗
                                        margin: '0' // 关键修改5：清除该单元格空白
                                    };

                                    // 关键修改6：表体行添加 margin: 0; padding: 0;
                                    return h('tr', { key: index, style: { margin: '0', padding: '0' } }, [
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, stock.planNumber || ''),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, stock.productId || ''),
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, `${productNums}`),
                                        h('td', { style: boxNumberTdStyle }, `${boxNumber}`), // 应用动态样式
                                        h('td', { style: { border: '1px solid #eee', padding: '8px 5px', textAlign: 'center', margin: '0' } }, statusText)
                                    ]);
                                })
                            )
                        ])
                    ]);
                }
            },
            {
                title: '操作',
                width: 200, // 加宽操作栏，适配多个按钮
                fixed: 'right',
                render: (h: any, params: any) => {
                    const row = params.row;
                    return h('div', [
                        // 1. 编辑基础信息（仅计划批次号）
                        h('Button', {
                            props: { type: 'primary', size: 'small', icon: 'ios-create' },
                            style: { marginRight: '5px', marginTop: '5px', width: '150px' },
                            on: { click: () => this.modifyBaseInfo(row) }
                        }, "编辑计划批次"),
                        // 2. 编辑扩展信息（唛头/运单号/备注）
                        h('Button', {
                            props: { type: 'warning', size: 'small', icon: 'ios-paper' },
                            style: { marginRight: '5px', marginTop: '5px', width: '150px' },
                            on: { click: () => this.modifyExtraInfo(row) }
                        }, "编辑基础信息"),
                        // 3. 编辑装箱详情（原有功能）
                        h('Button', {
                            props: { type: 'info', size: 'small', icon: 'ios-list' },
                            style: { marginRight: '5px', marginTop: '5px', width: '150px' },
                            on: { click: () => this.modifyDetail(row) }
                        }, "编辑装箱详情"),
                        // 4. 标记已处理（原有功能）
                        h('Button', {
                            props: { type: 'success', size: 'small', icon: 'ios-checkmark' },
                            style: { marginRight: '5px', marginTop: '5px', width: '150px', display: row.IsProcessed ? 'none' : 'inline-block' },
                            on: { click: () => this.markProcessed(row.id) }
                        }, "标记已处理"),
                        h('Button', {
                            props: { type: 'info', size: 'small', icon: 'ios-print' },
                            style: { marginTop: '5px', width: '150px', background: '#48b0f7', borderColor: '#48b0f7' },
                            on: { click: () => this.handlePrintWaybill(row) }
                        }, "打印面单"),
                        // 5. 删除（原有功能）
                        h('Button', {
                            props: { type: 'error', size: 'small', icon: 'ios-trash' },
                            style: { marginTop: '5px', width: '150px' },
                            on: { click: () => this.deletePack(row.id) }
                        }, "删除")
                    ]);
                }
            }
        ];

        // 产品状态枚举
        get ProductStatus() {
            return Enums.getEnum(Enums.ProductStatus, true);
        }

        // 初始化仓库列表（原有功能）
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            });
            const allStoreOption: storeaddressInfo = {
                id: null,
                storeName: "全部",
            } as storeaddressInfo;
            this.storeaddressList = [allStoreOption, ...this.$store.state.backstoreaddress.list];
        }

        // 创建装箱计划：打开基础信息弹窗（仅批次号）
        add() {
            this.$store.commit('frontPackingBatch/setPackingModel', { id: 0 });
            this.baseModalShow = true; // 切换为基础信息弹窗
        }

        handlePrintWaybill(row: any) {
            const shippingMark = row.shippingMark;
            // 2. 校验逻辑：空/纯空格都判定为未填写
            if (!shippingMark || shippingMark.trim() === '') {
                this.$Message.warning('请先填写唛头信息，否则无法打印！');
                return; // 终止方法执行，不打开弹框
            }
            this.currentRowData = row; // 存储当前行完整数据
            this.printModalShow = true; // 显示打印弹框
        }

        // 新增：编辑基础信息（仅计划批次号）
        modifyBaseInfo(row: any) {
            this.$store.commit('frontPackingBatch/setPackingModel', row);
            this.baseModalShow = true;
        }

        // 新增：编辑扩展信息（唛头/运单号/备注）
        modifyExtraInfo(row: any) {
            this.$store.commit('frontPackingBatch/setPackingModel', row);
            this.extraModalShow = true;
        }

        // 编辑装箱详情（原有功能）
        modifyDetail(row: any) {
            this.currentPackingPlanId = row.id;
            this.currentPackingDetailList = row.packingDetailList || [];
            this.currentProductIds = [];

            const stockList = row.inStockList || [];
            // forEach循环遍历
            stockList.forEach((stock: any) => {
                const productId = Number(stock.productId);
                if (productId > 0 && !isNaN(productId) && !this.currentProductIds.includes(productId)) {
                    this.currentProductIds.push(productId);
                }
            });
            this.detailModalShow = true;
        }

        // 标记已处理（原有功能）
        async markProcessed(id: number) {
            this.$Modal.confirm({
                title: "标记确认",
                content: "确定要标记该装箱计划为已处理吗？",
                onOk: async () => {
                    await this.$store.dispatch({
                        type: 'frontPackingBatch/processPack',
                        data: { id }
                    });
                    this.$Message.success("标记成功！");
                    this.getpage();
                }
            });
        }

        // 删除装箱计划（原有功能）
        async deletePack(id: number) {
            this.$Modal.confirm({
                title: "删除确认",
                content: "确定要删除该装箱计划吗？删除后不可恢复！",
                onOk: async () => {
                    await this.$store.dispatch({
                        type: 'frontPackingBatch/deletePackPlan',
                        data: { id }
                    });
                    this.$Message.success("删除成功！");
                    this.getpage();
                }
            });
        }

        // 分页切换（原有功能）
        pageChange(page: number) {
            this.$store.commit('frontPackingBatch/setCurrentPage', page);
            this.getpage();
        }

        // 每页条数切换（原有功能）
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontPackingBatch/setPageSize', pagesize);
            this.getpage();
        }

        // 搜索（原有功能）
        async searchPage() {
            this.$store.commit('frontPackingBatch/setCurrentPage', 1);
            this.getpage();
        }

        // 获取列表数据（原有功能）
        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            this.pagerequest.userId = this.$store.state.user.id;

            // 处理日期范围
            if (this.creationTime.length > 0) {
                this.pagerequest.startDate = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endDate = this.creationTime[1];
            }

            await this.$store.dispatch({
                type: 'frontPackingBatch/getPackingBatchList',
                data: this.pagerequest
            });
        }

        // 页面初始化（原有功能）
        async created() {
            await this.getData();
            this.getpage();
        }
    }
